/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress
 */
export interface ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress {
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress
     */
    college_university_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress
     */
    city_nm?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress
     */
    state_abbreviation_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress
     */
    country_cd?: string;
}

/**
 * Check if a given object implements the ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress interface.
 */
export function instanceOfExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddressFromJSON(json: any): ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress {
    return ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddressFromJSONTyped(json, false);
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'college_university_name': !exists(json, 'college_university_name') ? undefined : ExecRiskBusinessNameFromJSON(json['college_university_name']),
        'city_nm': !exists(json, 'city_nm') ? undefined : json['city_nm'],
        'state_abbreviation_cd': !exists(json, 'state_abbreviation_cd') ? undefined : json['state_abbreviation_cd'],
        'country_cd': !exists(json, 'country_cd') ? undefined : json['country_cd'],
    };
}

export function ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddressToJSON(value?: ExecRiskApiAppCoreModelsScansForm990ScheduleAAgriculturalNameAndAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'college_university_name': ExecRiskBusinessNameToJSON(value.college_university_name),
        'city_nm': value.city_nm,
        'state_abbreviation_cd': value.state_abbreviation_cd,
        'country_cd': value.country_cd,
    };
}

